import { useState } from "react";
import { BrowserRouter as Router, Routes, Route, useNavigate } from "react-router-dom";
import { signInWithEmailAndPassword, signInWithPopup, GoogleAuthProvider, getAuth } from "firebase/auth";
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

import { Button, Box, Typography, Paper, TextField, IconButton, InputAdornment } from "@mui/material";
import { Facebook, Twitter, Google, Lock, Person } from "@mui/icons-material";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();
export const db = getFirestore(app);

export default function LoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const handleEmailLogin = async () => {
    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      const userObject = {
        email: userCredential.user.email,
        provider: 'email'
      };
      localStorage.setItem('user', JSON.stringify(userObject));
      navigate("/app/dashboard");
    } catch (err) {
      setError("Invalid email or password. Please try again.");
    }
  };

  const handleGoogleLogin = async () => {
    try {
      const result = await signInWithPopup(auth, googleProvider);
      const userObject = {
        email: result.user.email,
        displayName: result.user.displayName,
        provider: 'google',
        photoURL: result.user.photoURL
      };
      localStorage.setItem('user', JSON.stringify(userObject));
      navigate("/app/dashboard");
    } catch (err) {
      setError("Google sign-in failed. Please try again.");
    }
  };

  return (
    <Box display="flex" alignItems="center" justifyContent="center" height="100vh">
      <Paper elevation={3} sx={{
        padding: 4,
        borderRadius: 5,
        textAlign: "center",
        maxWidth: 400,
        width: "100%",
        background: "inherit"
      }}>
        <Typography variant="h4" fontWeight="bold" gutterBottom>
          Login
        </Typography>
        <Box display="flex" flexDirection="column" gap={2}>
          <TextField 
            variant="outlined" 
            fullWidth 
            placeholder="Type your username" 
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Person color="disabled" />
                </InputAdornment>
              )
            }}
            value={email} 
            onChange={(e) => setEmail(e.target.value)}
          />
          <TextField 
            type="password" 
            variant="outlined" 
            fullWidth 
            placeholder="Type your password" 
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Lock color="disabled" />
                </InputAdornment>
              )
            }}
            value={password} 
            onChange={(e) => setPassword(e.target.value)}
          />
          {error && <Typography color="error" textAlign="center">{error}</Typography>}
          <Button 
            variant="contained" 
            fullWidth 
            sx={{
              mt: 1, 
              background: "linear-gradient(to right, #6a11cb, #2575fc)",
              color: "white",
              borderRadius: "50px"
            }}
            onClick={handleEmailLogin}
          >
            LOGIN
          </Button>
          <Typography variant="body2" color="textSecondary">
            Or Sign Up Using
          </Typography>
          <Box display="flex" justifyContent="center" gap={2}>
            <IconButton sx={{ color: "#DB4437" }} onClick={handleGoogleLogin}><Google /></IconButton>
          </Box>
        </Box>
      </Paper>
    </Box>
  );
}
